import axios from 'axios';
import I18n from '../../../i18n/i18n';

export default function getToastMessage(msg) {
    const timeoutErrorMsg = `timeout of ${axios.defaults.timeout}ms exceeded`;
    let toastMessage = msg;
    if (toastMessage === timeoutErrorMsg) toastMessage = I18n.t('timeoutError');

    return toastMessage;
}